import http from '../common/http'

export const GetMerchantStaffList = obj => (
  http.get('/staff/GetStaffList', { ...obj })
)
export const GetStoreStaffList = obj => (
  http.get('/staff/GetStaffList', { ...obj })
)
export const EmployerInsertAndEdit = obj => (
  http.post('/staff/InsertAndEditEmployer', { ...obj })
)
export const QueryEmployerById = employerId => (
  http.get('/staff/QueryEmployerById', {employerId: employerId})
)
export const EmployerUntieRelation = obj => (
  http.post('/staff/EmployerUntieRelation', {...obj})
)
export const  GetRepaireListByShopNo = storeId =>( // 获取门店维修师列表
	http.get('/Staff/GetStoreRepairerList',{storeId:storeId})
)



// WEBPACK FOOTER //
// ./src/api/staffApi.js